<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'>
      <div class='grid-wrap'>
        <dx-data-grid ref='refDokubGrid'
          :data-source='purchaseInfoList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :auto-navigate-to-focused-row="false"
          key-expr="seqId"
          :height='gridHeight'
          @toolbar-preparing='onToolbarPreparing'
          @row-updated="onRowUpdated"
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            :file-name="excelFileName"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxEditing
            :allow-deleting="false"
            :allow-updating="isEditable"
            :allow-adding="false"
            :use-icons="true"
            mode='row'
          />
          <DxColumn v-if="pType === '하드웨어'"
            :allowEditing="false"
            caption="계열명"
            data-field="본사코드"
          >
            <DxLookup
              :data-source="groupLookupInfo"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="마감처명"
            data-field="거래처코드"
            :visible='true'
            sort-order='asc'
          >
              <DxLookup
              :data-source="partnerLookup"
              display-expr="거래처명"
              value-expr="거래처코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="입고일"
            data-field="발생일자"
            dataType='date'
            sort-order='asc'
            format='yyyy-MM-dd'>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="마감월"
            data-field="마감일자"
            dataType='date'
            :editor-options="{calendarOptions: {maxZoomLevel: 'year', minZoomLevel: 'century'}}"
            format='yyyy-MM'>
          </DxColumn>
          <DxColumn
            v-if="$store.getters.getGroupName !== null"
            :caption="$store.getters.getGroupName"
            data-field="차종"
            width="80"
            :allowEditing='false'
            :visible="pType==='외주품'"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="품번"
            data-field="품번"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="품명"
            data-field="품명"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="품목유형"
            data-field="품목유형"
            :visible='true'
            width='80'
          >
            <DxLookup
              :data-source="itemTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="자재유형"
            data-field="자재유형"
            :visible='true'
            width='80'
          >
            <DxLookup
              :data-source="materialTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="단가"
            data-field="가격"
            :visible='true'
            dataType="number"
            format='#,##0.0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="구매수량"
            data-field="구매수량"
            :visible='true'
            dataType="number"
            format='#,##0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="구매금액"
            data-field="구매금액"
            :visible='true'
            dataType="number"
            format='#,##0.0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="납품/고객사"
            data-field="납품처코드"
            :visible='true'
          >
              <DxLookup
              :data-source="customerLookup"
              display-expr="거래처명"
              value-expr="거래처코드"
            />
          </DxColumn>
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              column="거래처코드"
              display-format="{0} (건)"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="구매수량"
              display-format="{0}"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="구매금액"
              display-format="{0}"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
        <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxTotalItem, DxLookup, DxEditing,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxExport } from 'devextreme-vue/data-grid'
import DxTabPanel from 'devextreme-vue/tab-panel'
export default {
  name: 'MonthPressPurchaseList',
  data: function () {
    return {
      isLoading: false,
      selectedIndex: 0,
      tabs: [
        {
          title: this.tabTitle
        }
      ],
      userInfo: null,
      gridHeight: null,
      purchaseInfoList: null,
      selectedRow: null,
      thisYear: null,
      yearArray: [],
      thisMonth: null,
      monthArray: [],
      exportTitle: null,
      receiptTypeLookup: null,
      editSubButtons: ['edit', 'delete'],
      meterialTypeLookup: null,
      customerLookup: this.$store.getters.getFirstVendor,
      partnerLookup: this.$store.getters.getPartnersInfo,
      itemTypeLookup: this.$store.getters.getBaseDataByType(ConstDef.품목유형),
      materialTypeLookup: this.$store.getters.getBaseDataByType(ConstDef.자재유형),
      excelFileName: null,
      groupLookupInfo: this.$store.getters.getBaseDataByType(ConstDef.거래처그룹)
    }
  },
  props: {
    materialType: {
      type: String,
      default: ConstDef.외주품
    },
    pType: {
      type: String,
      default: '외주품'
    },
    tabTitle: {
      type: String,
      default: '외주품입고내역'
    }
  },
  components: {
    DxTabPanel,
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxExport,
    DxEditing,
    DxLookup
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    // this.$store.commit('deleteInoutList')
    this.thisYear = AppLib.getThisYear()
    for (let i = this.thisYear; i >= 2021; i--) {
      this.yearArray.push({ 'year': i })
    }
    this.thisMonth = AppLib.getThisMonth()
    for (let i = 1; i <= 12; i++) {
      if (i > 0 && i < 10) {
        this.monthArray.push({ 'name': i + '월', value: '0' + i })
      } else {
        this.monthArray.push({ 'name': i + '월', value: '' + i })
      }
    }
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.receiptTypeLookup = ConstDef.PURCHASE_INOUT_CODE
    if (this.materialType !== ConstDef.외주품) {
      this.customerLookup = this.$store.getters.getPartnersInfo
      this.partnerLookup = this.$store.getters.getCompanyInfo
    }

    this.refreshInventoryList()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {
    // this.$store.commit('deleteInoutList')
  },
  methods: {
    calcAmount (row) {
      if (row.입출고구분 === ConstDef.자재입고) {
        return row.수량 * row.가격
      }
      return null
    },
    isEditable (row) {
      return AppLib.isInOutCRUDable(row.row.data.발생일자)
    },
    onRowUpdated (row) {
      console.log(row.data)
      this.$_sp.runUpdateSqlProc('창고수불', ['seqId'], null, [{ seqId: row.data.seqId, 마감일자: row.data.마감일자 }])
        .then((data) => {
          // this.refresPurchaseDetail(this.item.key, this.item.data.자재유형)
          // this.$snotify.info('마감일 작업이 모두 완료 되었으면 페이지 리프레쉬 하여 주세요')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },

    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.yearArray,
            valueExpr: 'year',
            displayExpr: 'year',
            value: this.thisYear,
            onValueChanged: (args) => {
              this.$store.commit('deleteInoutList')
              this.thisYear = args.value
              this.refreshInventoryList()
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.monthArray,
            valueExpr: 'value',
            displayExpr: 'name',
            value: this.thisMonth,
            onValueChanged: (args) => {
              this.$store.commit('deleteInoutList')
              this.thisMonth = args.value
              this.refreshInventoryList()
            }
          }
        }
      )
    },
    refreshInventoryList () {
      this.excelFileName = `${this.thisYear}-${this.thisMonth}-${this.pType}입고내역`
      this.isLoading = true
      let endDate = `${this.thisYear}-${this.thisMonth}-${AppLib.getMonthLastDay(this.thisYear, this.thisMonth)}`
      endDate = AppLib.calcDateFromFormat(endDate, 1)
      let param = {
        fromDate: `${this.thisYear}-${this.thisMonth}-01`,
        toDate: `${endDate}`,
        자재유형: this.materialType
      }
      this.$_sp.runNoEncodeFindProc('spFindAllPurchaseDetalBillByMonthAndPtype', param)
        .then((data) => {
          this.isLoading = false
          this.purchaseInfoList = this.$_sp.MakeModel(data)
          console.log(this.purchaseInfoList)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
